<template>
  <div>
  <div class="row">
    <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-2">
      <b-form-input placeholder="ID:"
                    size="sm"
                    class="sizePlus"
                    v-model="filters.network_partner_id">
      </b-form-input>
    </div>
    <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-2">
      <v-select label="name" :options="buyers"
                :reduce="user => user.id"
                v-model="filters.buyers"
                placeholder="Медиабайер" multiple>
        <span slot="no-options">Совпадений не найдено.</span>
      </v-select>
    </div>
    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 mb-2">
      <b-btn size="sm" text="Search" variant="success"
             class="mainButton"
             style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
             @click="getUsersWithPartnerNetworkId(true)">
        <i class="icon-fa icon-fa-search"></i>
      </b-btn>
    </div>
  </div>
    <div class="row">
      <div class="col-sm-12">
        <div v-if="!isMobile">
          <b-table hover responsive bordered
                   small
                   :items="filteredBuyers"
                   :fields="fields"
                   no-local-sorting>
          </b-table>
        </div>
        <div v-if="isMobile">
          <b-table hover responsive bordered stacked
                   small
                   :items="filteredBuyers"
                   :fields="fields"
                   no-local-sorting>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ConversionsService from '../../../services/conversionsDataService'

export default {
  name: "BuyersTableModal",
  data() {
    return {
      filters: {
        buyers: [],
        network_partner_id: null,
      },
        buyers: [],
        isMobile: false,
      filteredBuyers: [],
        fields: [
            {
                key: 'name',
                label: 'Name',
                sortable: false
            },
            {
                key: 'network_partner_id',
                label: 'Network Partner Id',
                sortable: false
            },
        ]
    }
  },
  methods: {
    getUsersWithPartnerNetworkId(isFilter) {
      ConversionsService.getUsersWithPartnerNetworkId(this.filters)
              .then(users => {
                this.filteredBuyers = users
                if (!isFilter) {
                  this.buyers = users
                }
              })
    },
    filterBuyers() {
      if (!this.idCriteria && this.buyerArray.length == 0) {
         this.filteredBuyers = this.buyers

        return
      }


      return
    }

  },
  mounted() {
    this.getUsersWithPartnerNetworkId()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/BuyersTableModal.vue